import { useTranslation } from "react-i18next";
import { Button } from "@ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ui/components/ui/dialog";
import { Separator } from "@ui/components/ui/separator";

interface NavigationBlockerDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
}

export const NavigationBlockerDialog: React.FC<
  NavigationBlockerDialogProps
> = ({ isOpen, onConfirm, onCancel, title, description }) => {
  const { t } = useTranslation("Shared");

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="!p-0 !gap-0">
        <DialogHeader className="px-6 py-[18px] text w-full">
          <DialogTitle className="text-medium font-semibold text-text-2">
            {title ||
              t("navigationBlocker.title", { defaultValue: "Unsaved Changes" })}
          </DialogTitle>
        </DialogHeader>
        <Separator />
        <DialogDescription className="text-base font-semibold !text-black py-8 px-6">
          {description ||
            t("navigationBlocker.description", {
              defaultValue:
                "You have unsaved changes that will be lost if you leave this page. Are you sure you want to continue?",
            })}
        </DialogDescription>
        <Separator />
        <DialogFooter className="py-[16px] px-6 flex self-end">
          <Button dark={"outline"} size={"small"} onClick={onCancel}>
            {t("navigationBlocker.cancel", { defaultValue: "Cancel" })}
          </Button>
          <Button primary={"default"} size={"small"} onClick={onConfirm}>
            {t("navigationBlocker.confirm", { defaultValue: "Leave Page" })}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
